import React, { useState } from 'react';

const Submenu = ({ tab, handleClick, accountAddress }) => {
  const [selectedTab, setSelectedTab] = useState(tab);
  const tabClassName = (tabName: string) => {
    return (selectedTab === tabName) ? 'border-b-2 selected-color cursor-pointer' : 'cursor-pointer';
  };
  
  return (<div className='flex flex-row justify-start gap-10 primary-text-color py-7 text-2xl font-semibold'>
    <div 
      className={tabClassName('Vaults')} 
      onClick={() => {setSelectedTab('Vaults'); handleClick('Vaults');}}>
      Vaults
    </div>
    {accountAddress && (
      <div 
        className={tabClassName('My Deposits')} 
        onClick={() => {setSelectedTab('My Deposits'); handleClick('My Deposits');}}>My Deposits
      </div>
    )}
  </div>);
};

export default Submenu;
